export const ExplainMedicine = {
  ReservationDetail: {
    ReservationContent: '予約内容',
    Resend: '再送信する',
    Hospital: '処方箋を送信する医療機関名',
  },
  Status: {
    Label: 'ステータス',
    InProgress: '進行中',
    Done: '完了',
    Cancel: 'キャンセル',
  },
  OrderNumber: {
    Label: '受付番号',
  },
  ReservationDate: {
    Label: '予約日時',
  },
  User: {
    Label: '患者さまのお名前',
  },
  Pharmacy: {
    number: '薬局の電話番号',
  },
  Answer: {
    Label: '薬局からのメッセージ',
  },
  PaymentDetail: {
    TotalPayment: '請求金額',
    Settlement: 'お薬代を支払う',
    Medicine: 'お薬代',
    DeliveryPrice: '配送料金',
    Others: 'その他',
    Yen: '円',
  },
  CreditCard: {
    Label: 'クレジットカード情報',
    Number: 'カード番号',
    ExpiredDate: '有効期限',
    Brand: 'ブランド',
    Cardholder: 'カード名義人',
  },
  DeliveryStatus: {
    Status: '配送状況',
    Confirm: '配送状況を確認する',
    Cancel: 'この予約をキャンセルする',
    Delivery: '未配送',
    Delived: '配送済',
  },
  NotExistsPicture: {
    Note: '保存期間が終了したため表示できません。',
  },
  CancelDialog: {
    Text: '予約をキャンセルしますか？',
    TextUseMyna:
      '予約をキャンセルしますか？\nマイナ保険証の提供同意状態は取り消されませんので、同意登録を取り消す場合は、予約履歴の予約内容画面から行ってください。',
    Ok: '予約をキャンセルする',
    No: '戻る',
    Canceld: '予約をキャンセルしました。',
    NoTakeBackCaution: '※再予約は移行先にて承ります。',
  },
  SettlementDialog: {
    Canceld: 'お薬代の請求・決済が取り消されました。',
    Complete: 'お薬代のお支払いが完了しました。',
  },
};
